<template>
    <div class="InfoMain">
        <p class="current">当前位置：<span>报名详情</span></p>
        <div class="MainInfoSelf">
            <div class="InfoSelf-box">
                <p>培训名称：</p>
                <span>{{ vsData.name }}</span>
            </div>
            <div>
                <div  class="InfoSelf-box" >
                    <p>姓名：</p>
                    <span>{{ vsData.real_name }}</span>
                </div>
                <div  class="InfoSelf-box" >
                    <p>手机号码：</p>
                    <span>{{ vsData.phone }}</span>
                </div>
                
                <div class="InfoSelf-box">
                    <p>身份证号码：</p>
                    <span>{{ vsData.id_number }}</span>
                </div>
                <div class="InfoSelf-box">
                    <p>状态：</p>
                    <span>{{ vsData.ispay == 0 ? '未付款':'已付款' }}</span>
                </div>
                <div class="InfoSelf-img" style="display: block;">
                    <p>附件图片：</p>
                    <div v-for="item in vsData.file_items" :key="item.id" class="imgItems">
                        <div :style="'width: 150px; height: 150px;margin: 20px 30px 0 0;background-image:url('+item.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                    </div>
                    
                </div>
                <div class="InfoSelf-box" style="display: block;border: none;">
                    <p>备注：</p>
                    <p class="remarksP">{{ vsData.remarks }}</p>
                </div>
            </div>
            
            <div class="InfoSelf-box" style="border: none;margin-top: 20px;">
                <el-button type="primary" v-if="((vsData.ispay=='0'))">付款</el-button>
            </div>
        </div>
            
    </div>

</template>
<script>
export default{
    data(){
        return{
            vsData: {}
        }
    },
    methods: {
      
    },
    mounted(){
        let data = {
            id: this.$route.query.id
        }
        this.$store.dispatch('personal/bookingInfoByUser',data)
            .then(res => {
                if(res.ok){
                    this.vsData = res.data
                    
                }
            })
    }
}
</script>
<style scoped>
@import url(../../css/personalInfo.css);


.imgItems{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: row wrap;
}
.remarksP{
    width: 880px;
    margin-top: 20px;
    background: #f1f1f1;
    padding: 8px 20px 20px 8px;
    color: #4095e5;
}
@media screen and (max-width: 540px) {
    .remarksP{
        width: 100%;
        margin-top: 20px;
        background: #f1f1f1;
        padding: 8px 0px 20px 0px;
        color: #4095e5;
    }
    .imgItems{
        margin-left: 10px
    }
}
@import url(../../css/personalInfo540.css);
</style>